import * as api from './api';
import * as apiMerp from './api-merp';

export function get(options: any) {
  return api.get(`references`, options);
}

export function getByReferenceCode(referenceCode: string) {
  return api.get(`references/${referenceCode}`);
}

export function getByCollectionId(collectionId: number, options: any) {
  return api.get(`references/collection/${collectionId}`, options);
}

export function getPack(referenceCode: string) {
  return api.get(`references/pack/${referenceCode}`);
}

export function getReferenceProducts(referenceCode: string) {
  return api.get(`products/${referenceCode}`);
}

export function updateReferenceStatus(referenceCode: string, isActive: boolean) {
  return api.patch(`references/${referenceCode}`, { property: 'isActive', value: isActive });
}

export function updatePack(referenceCode: string, body: any) {
  return api.put(`references/pack/${referenceCode}`, body);
}

export function createReferenceWithIntegration(body: any) {
  return apiMerp.post(`references`, body);
}

export function searchReference(body: any) {
  return apiMerp.post(`references/search-references`, body);
}

export function getReferenceDetails(referenceCode: string) {
  return apiMerp.get(`references/${referenceCode}`);
}
